import { v4 as uuidv4 } from "uuid";
export class EntryUpComingEventModel {
    constructor() {
        this.id = uuidv4();
        this.description = "";
        this.dueDateAsString = "";
    }
}
export default class EntryUpComingEvent extends EntryUpComingEventModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
